<template>
  <!-- The signed-out screens' only language control: one word naming the OTHER
       language, the way Québec sites do it. The browser's language already
       chose the page (lib/locale.ts), so this is for the rare mismatch. -->
  <button
    type="button"
    :lang="other"
    class="text-sm font-medium text-muted-foreground underline underline-offset-4 decoration-input hover:text-foreground transition-colors"
    @click="switchTo(other)"
  >
    {{ LABELS[other] }}
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { persistLocale, type AppLocale } from '@/lib/locale'

// Not translated: a language is named in its own words, whatever the page says.
const LABELS: Record<AppLocale, string> = { fr: 'Français', en: 'English' }

const { locale } = useI18n()
const other = computed<AppLocale>(() => (locale.value === 'en' ? 'fr' : 'en'))

const switchTo = (next: AppLocale) => {
  locale.value = next
  persistLocale(next)
}
</script>
